import * as React from 'react';
import * as SRD from "storm-react-diagrams";
import AppUtils from '../utils/AppUtils';
import ReactHtmlParser from 'react-html-parser';
require("storm-react-diagrams/dist/style.min.css");
import '../sass/StoryDiagram.css';
// import ChapterTitleComponent from './storyEditComponent/ChapterTitleComponent';
//import { distributeElements } from "./dagre-utils";
import { Fade, DropdownButton, MenuItem } from 'react-bootstrap';

export default class StoryDiagram extends React.Component<any, any> {
    
    private diagromStoreArray:Array<number> = [];
    private OFFSET_X:number = 350;
    private OFFSET_Y:number = 300;

    constructor(props:any) {
        super(props);

        this.state = {
            engine: null,
            diagramLoaded: false,
            diagramVisible: false,
        }

        this.showDiagram = this.showDiagram.bind(this);
        this.hideDiagram = this.hideDiagram.bind(this);

        console.log("Showing story diagram");
    }

    private canShowDiagram():boolean {
      if (!AppUtils.isMobile && this.props.isStoryViewPanelVisible) {
        return true;
      }
      return false;
    }

    private newLinkCreated(e:any) {
      console.log("new link event: ", e);
    }

    linksUpdated (event: any) {
      console.log("link did something")
      event.link.addListener({
        /**
         * selectionChanged
         * Perform action when link is selected
         */
        selectionChanged: e => {
          console.log("selection changed")
          event.link.addLabel('welcome');
        },
        /**
         * entityRemoved
         * Perform action when link is removed
         */
        entityRemoved: e => {
          //
          console.log("link removed")
        }
      });
    }

    componentWillMount() {
      this.setupDiagramEngine();
    }

    private setupDiagramEngine() {
        console.log("Setting up diagram engine");
        var engine = new SRD.DiagramEngine();
        
        engine.installDefaultFactories();
        // engine.setSmartRoutingStatus(true);
        // engine.setMaxNumberPointsPerLink(3);
        var model = new SRD.DiagramModel();
        model.addListener({
          nodesUpdated: function(e){
            console.log("Nodes updated")
          },
          zoomUpdated: function(e){
            console.log("zoom updated")
          },
          linksUpdated: e => {
            this.linksUpdated(e);
          }
        });
        this.addDiagramNode(model, this.props.storys[0].id, null, 0, 1);
        engine.setDiagramModel(model);
        this.setState({engine: engine, diagramLoaded: true});
    }

    private addDiagramNode(model:SRD.DiagramModel, pageNum:number, fromPort:any, yPos:number, columnNum) {
      if (columnNum > this.diagromStoreArray.length) {
        this.diagromStoreArray.push(0);
      }
      let nodeAlreadyExists = model.getNode('Page'+pageNum);
      if (nodeAlreadyExists) {
        // console.log("Already exists!"); 
        let link:SRD.LinkModel = fromPort.link(nodeAlreadyExists.getPort('inPort'));
        model.addLink(link);
        return;
      }
      let pageIndex:number = AppUtils.findIndexByKey(this.props.storys, "id", pageNum);
      // console.log(pageIndex, pageNum);
      if (pageIndex != null && pageIndex != -1) {
        let node = new SRD.DefaultNodeModel('Page ' + (pageIndex + 1));
        // console.log("Adding:",pageIndex,this.props.storys[pageIndex].text,this.props.storys[pageIndex].decisions.length)
        node.id = 'Page' + pageNum;
        
        this.diagromStoreArray[columnNum-1] += 1;
        //console.log(this.diagromStoreArray);
        yPos = ((this.diagromStoreArray[columnNum-1] * 300)) - this.OFFSET_Y;
        // yPos = 0;
        node.setPosition((columnNum*350) - this.OFFSET_X, yPos);
        columnNum++;
        let inPort:SRD.DefaultPortModel = new SRD.DefaultPortModel(true, 'inPort', ReactHtmlParser(this.props.storys[pageIndex].text));
        node.addPort(inPort);
        if (pageIndex != 0) {
          let link:SRD.LinkModel = fromPort.link(inPort);
          model.addLink(link);
        }
        model.addNode(node);
        for (let n = 0; n < this.props.storys[pageIndex].decisions.length; n++) {
          var outPort:SRD.DefaultPortModel = new SRD.DefaultPortModel(false, 'outPort', this.props.storys[pageIndex].decisions[n].decision, n.toString());
          outPort.label = this.props.storys[pageIndex].decisions[n].decision;
          outPort.id = n.toString();
          outPort.name = n.toString();
          node.addPort(outPort);

          if(this.props.storys[pageIndex] != null) {
            let jumpPage:number = parseInt(this.props.storys[pageIndex].decisions[n].jumpPage);
            if (jumpPage != null && isNaN(jumpPage) == false && jumpPage != undefined) {
              this.addDiagramNode(model, jumpPage, outPort, 300 * n, columnNum)
            }
          }
        }
      }
    }
  
    private SimpleDiagramWidget(props) {
      // console.log(this.props.engine);
      if (this.state.engine == null) {
        return <div></div>
      }
      return <SRD.DiagramWidget smartRouting={false} maxNumberPointsPerLink={5} diagramEngine={this.state.engine} />;
    }

    private showDiagram() {
      this.setState({diagramVisible: true})
    }

    private hideDiagram() {
      this.setState({diagramVisible: false})
    }

    private handleChangeChapter() {

    }

    render() {
        return (
            <Fade in={this.canShowDiagram()} onEntering={this.showDiagram}>
            <div id='diagramContainer' className="pageContainer">
              <div id="header">
                <h2 className="pageHeader">Story Viewer (Alpha)</h2>
                <div id="chapterButtons">
                    <DropdownButton
                        className="dropdownBtn chapterSelectionDropdown"
                        bsStyle={"default"}
                        title={this.props.chapters[this.props.currentChapter].name}
                        key={"btnKey1"}
                        id="input-dropdown-addon"
                        >
                        <MenuItem divider />
                        <MenuItem header>Chapters</MenuItem>
                        {this.props.chapters.map((c:any, i:number) => <MenuItem id={c.id} key={c.id} title={this.props.chapters[i].name} onSelect={this.handleChangeChapter.bind(this)}>{this.props.chapters[i].name}</MenuItem>)}
                    </DropdownButton>
                </div>
                </div>
                { AppUtils.isMobile == false && this.props.userData.admin == true ?
                  this.SimpleDiagramWidget(this.props) : null
                }
            </div>
            </Fade>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/StoryDiagram.tsx